/* eslint-disable */
// @ts-nocheck
import { createLucideIcon } from 'lucide-react';

// Define the icon nodes
const iconNodes = [
  ["path", {"d":"M3.997 13.899A7 7 0 1 1 15.707 7h1.79a4.5 4.5 0 0 1 2.5 8.242M14 16v-2a2 2 0 0 0-4 0v2m-1 0h6a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1","strokeWidth":"2","key":"y4z93m"}]
];

// Create and export the icon component
export const PrivateCloudIcon = createLucideIcon("private-cloud", iconNodes);
